import inView from 'in-view';

export default {
    _selector: '[data-animated]',
    _transitionDuration: 1500,

    init() {
        inView.threshold(.9);
        inView(this._selector).on('enter', el => {
            this._zoomout(el);
        }).on('exit', el => {
            this._zoomin(el);
        });
    },
    _zoomin(el) {
        const images = el.querySelectorAll('[data-animated-image]'); 
        for (const image of images) {
            image.classList.add('viewOut');
            image.classList.remove('viewIn');
        } 
    },

    _zoomout(el) {
        const images = el.querySelectorAll('[data-animated-image]');
        for (const image of images) {
            image.classList.remove('viewOut');
            image.classList.add('viewIn');
        }
    }
}